var _path, _path2, _path3, _path4, _path5, _rect, _g, _path6, _path7, _rect2, _g2, _rect3, _g3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStrawberry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140 275C65.4 275 5 214.6 5 140C5 65.4 65.4 5 140 5C214.6 5 275 65.4 275 140C275 214.6 214.6 275 140 275Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.173 64.6113C185.532 60.9278 197.326 55.199 196.514 51.8156C195.703 48.4323 182.594 48.6756 167.235 52.359C151.875 56.0425 140.082 61.7713 140.893 65.1547C141.704 68.538 154.813 68.2948 170.173 64.6113Z",
    fill: "#009D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M166.399 69.2348C167.929 65.9265 157.629 57.9068 143.394 51.3223C129.158 44.7378 116.377 42.0819 114.847 45.3901C113.317 48.6984 123.617 56.7181 137.852 63.3026C152.088 69.8871 164.868 72.5431 166.399 69.2348Z",
    fill: "#009D00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.717 178.639L118.745 179.299L121.882 217.17L129.855 216.51L126.717 178.639Z",
    fill: "#3A3A3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.3 178.9H163.3V216.9H171.3V178.9Z",
    fill: "#3A3A3A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_468",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 229,
    width: 90,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 229,
    width: 90,
    height: 15,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.8 241.9C171.272 241.9 190.3 239.661 190.3 236.9C190.3 234.139 171.272 231.9 147.8 231.9C124.328 231.9 105.3 234.139 105.3 236.9C105.3 239.661 124.328 241.9 147.8 241.9Z",
    fill: "#BFC3CE"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.8 234.9C127.465 234.9 135.3 229.975 135.3 223.9C135.3 217.825 127.465 212.9 117.8 212.9C108.135 212.9 100.3 217.825 100.3 223.9C100.3 229.975 108.135 234.9 117.8 234.9Z",
    fill: "#3A3A3A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.8 234.9C185.465 234.9 193.3 229.975 193.3 223.9C193.3 217.825 185.465 212.9 175.8 212.9C166.135 212.9 158.3 217.825 158.3 223.9C158.3 229.975 166.135 234.9 175.8 234.9Z",
    fill: "#3A3A3A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_468",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 216,
    width: 10,
    height: 10
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 216,
    width: 10,
    height: 10,
    fill: "url(#pattern1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.8 223.9C109.181 223.9 110.3 222.781 110.3 221.4C110.3 220.019 109.181 218.9 107.8 218.9C106.419 218.9 105.3 220.019 105.3 221.4C105.3 222.781 106.419 223.9 107.8 223.9Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_468",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 182,
    y: 216,
    width: 10,
    height: 10
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 216,
    width: 10,
    height: 10,
    fill: "url(#pattern2)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.8 223.9C188.181 223.9 189.3 222.781 189.3 221.4C189.3 220.019 188.181 218.9 186.8 218.9C185.419 218.9 184.3 220.019 184.3 221.4C184.3 222.781 185.419 223.9 186.8 223.9Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M169.2 43.1C169.2 44.4 168.7 45.6 167.9 46.5C166.9 47 165.9 47.5 164.9 48.1C156.7 53 151.2 61.9 151.2 72.1C151.2 72.2 151.2 72.3 151.2 72.4C150.3 72.2 149.3 72.1 148.2 72.1C146.8 72.1 145.4 72.3 144.2 72.6C143.5 70.2 143.2 67.7 143.2 65.1C143.2 52.9 150.9 42.6 161.8 38.7C162.4 38.5 163.1 38.3 163.7 38.1C163.9 38.1 164 38.1 164.2 38.1C167 38.1 169.2 40.3 169.2 43.1Z",
    fill: "#6E3126"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5 123.8C80.5 123.8 67.5 138.8 69.5 141.8C71.5 144.8 78.5 146.8 82.5 148.8C86.5 150.8 96 159.8 91.7 161.3C87.4 162.8 83.9 163.8 82.2 161.3",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M209.8 116C209.8 120 209.1 123 208.8 125C206.8 137 201.8 145.5 195.5 155.3C184.4 172.6 165.3 203.8 143.3 203.8C108.8 203.8 83.8 155.9 80.4 121.5C79.8 115.5 78.9 109.9 79.6 104.3C79.7 103.2 79.8 102.2 79.8 101.1C79.9 98.6 80.2 95.8 80.8 93C81 91.7 81.5 89.9 81.6 88.6C81.6 88.4 81.6 88.3 81.7 88.1C81.7 87.9 81.8 87.7 81.8 87.6V87.5V87.4V87.3V87.2C81.8 87.1 81.8 87.1 81.8 87C81.8 86.9 81.8 86.8 81.8 86.8V86.7C84.7 69.3 99.8 56 118 56C122.8 56 127.5 56.9 131.7 58.6C132.3 59 132.9 59.3 133.5 59.7C134.9 60.5 136.4 61.2 137.9 61.8C142.1 63.5 146.7 64.5 151.6 64.5C153.6 64.5 155.5 64.3 157.4 64C159.6 63.7 161.7 63.1 163.7 62.4C164.1 62.3 164.5 62.1 164.9 62C168.3 60.7 171.9 59.9 175.6 60C177.1 60.1 178.6 60.2 180.2 60.5C197.9 63.4 210.7 79.2 210.7 97.2C210.5 103.8 210.8 109.3 209.8 116Z",
    fill: "url(#paint0_linear_1_468)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.8 165.3C155.181 165.3 156.3 164.181 156.3 162.8C156.3 161.419 155.181 160.3 153.8 160.3C152.419 160.3 151.3 161.419 151.3 162.8C151.3 164.181 152.419 165.3 153.8 165.3Z",
    fill: "#FCD728"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M182.2 137.5C183.581 137.5 184.7 136.381 184.7 135C184.7 133.619 183.581 132.5 182.2 132.5C180.819 132.5 179.7 133.619 179.7 135C179.7 136.381 180.819 137.5 182.2 137.5Z",
    fill: "#FCD728"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M175.8 103.3C177.181 103.3 178.3 102.181 178.3 100.8C178.3 99.4193 177.181 98.3 175.8 98.3C174.419 98.3 173.3 99.4193 173.3 100.8C173.3 102.181 174.419 103.3 175.8 103.3Z",
    fill: "#FCD728"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M147.8 118.3C149.181 118.3 150.3 117.181 150.3 115.8C150.3 114.419 149.181 113.3 147.8 113.3C146.419 113.3 145.3 114.419 145.3 115.8C145.3 117.181 146.419 118.3 147.8 118.3Z",
    fill: "#FCD728"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 187.3C133.181 187.3 134.3 186.181 134.3 184.8C134.3 183.419 133.181 182.3 131.8 182.3C130.419 182.3 129.3 183.419 129.3 184.8C129.3 186.181 130.419 187.3 131.8 187.3Z",
    fill: "#FCD728"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2 134.5C99.5807 134.5 100.7 133.381 100.7 132C100.7 130.619 99.5807 129.5 98.2 129.5C96.8193 129.5 95.7 130.619 95.7 132C95.7 133.381 96.8193 134.5 98.2 134.5Z",
    fill: "#FCD728"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M110.2 113.5C111.581 113.5 112.7 112.381 112.7 111C112.7 109.619 111.581 108.5 110.2 108.5C108.819 108.5 107.7 109.619 107.7 111C107.7 112.381 108.819 113.5 110.2 113.5Z",
    fill: "#FCD728"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2 96.5C88.5807 96.5 89.7 95.3807 89.7 94C89.7 92.6193 88.5807 91.5 87.2 91.5C85.8193 91.5 84.7 92.6193 84.7 94C84.7 95.3807 85.8193 96.5 87.2 96.5Z",
    fill: "#FCD728"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M139.2 102.5C140.581 102.5 141.7 101.381 141.7 100C141.7 98.6193 140.581 97.5 139.2 97.5C137.819 97.5 136.7 98.6193 136.7 100C136.7 101.381 137.819 102.5 139.2 102.5Z",
    fill: "#FCD728"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M123.2 78.5C124.581 78.5 125.7 77.3807 125.7 76C125.7 74.6193 124.581 73.5 123.2 73.5C121.819 73.5 120.7 74.6193 120.7 76C120.7 77.3807 121.819 78.5 123.2 78.5Z",
    fill: "#FCD728"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M159.2 87.5C160.581 87.5 161.7 86.3807 161.7 85C161.7 83.6193 160.581 82.5 159.2 82.5C157.819 82.5 156.7 83.6193 156.7 85C156.7 86.3807 157.819 87.5 159.2 87.5Z",
    fill: "#FCD728"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M170.2 76.5C171.581 76.5 172.7 75.3807 172.7 74C172.7 72.6193 171.581 71.5 170.2 71.5C168.819 71.5 167.7 72.6193 167.7 74C167.7 75.3807 168.819 76.5 170.2 76.5Z",
    fill: "#FCD728"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M103.8 75.3C105.181 75.3 106.3 74.1807 106.3 72.8C106.3 71.4193 105.181 70.3 103.8 70.3C102.419 70.3 101.3 71.4193 101.3 72.8C101.3 74.1807 102.419 75.3 103.8 75.3Z",
    fill: "#FCD728"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M109.8 160.3C111.181 160.3 112.3 159.181 112.3 157.8C112.3 156.419 111.181 155.3 109.8 155.3C108.419 155.3 107.3 156.419 107.3 157.8C107.3 159.181 108.419 160.3 109.8 160.3Z",
    fill: "#FCD728"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M128.8 166.3C130.181 166.3 131.3 165.181 131.3 163.8C131.3 162.419 130.181 161.3 128.8 161.3C127.419 161.3 126.3 162.419 126.3 163.8C126.3 165.181 127.419 166.3 128.8 166.3Z",
    fill: "#FCD728"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M210 116C210 120 209.3 123 209 125.1C207 137.2 202 145.8 195.7 155.6C184.6 173 165.8 203.2 143.8 203.3C157.7 198.8 168.9 170.8 176.7 158.7C183 148.9 188 140.3 190 128.2C190.3 126.4 190.9 123.8 191 120.3C191 119.5 191.1 118.7 191.2 117.9C192 111.6 191.7 106.4 191.7 100.1C191.6 82 181.6 66.6 163.9 63.6C163.7 63.6 160.8 63 160.6 63C161.7 62.7 162.7 62.4 163.8 62C164.2 61.9 164.6 61.7 165 61.6C168.4 60.3 172 59.5 175.7 59.6C177.2 59.7 178.7 59.8 180.2 60.1C197.9 63.1 210.7 78.9 210.7 97.1C210.6 103.7 210.9 109.2 210 116Z",
    fill: "url(#paint1_linear_1_468)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 125.9L100.5 133.1C100.4 135.6 98.3 137.5 95.8 137.4C93.3 137.3 91.4 135.2 91.5 132.7L91.8 125.5C91.9 123 94 121.1 96.5 121.2C99 121.3 100.9 123.4 100.8 125.9Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M115.3 91.7C115.3 93.2 114.7 94.5 113.8 95.5C113.4 95.8 113.1 96 112.8 96.3C108.5 100.1 105.4 105.3 104.3 111.2C104.2 111.5 104.2 111.8 104.1 112.1C103.5 114.4 101.3 116.1 98.8 116.1C96 116.1 93.8 114.1 93.4 111.5C93.4 111.1 93.3 110.7 93.3 110.3C93.3 110.1 93.3 109.8 93.3 109.6C93.3 100 98.6 91.6 106.6 87.1C107 86.9 107.4 86.6 107.9 86.4C108.5 86.2 109.2 86 109.8 86C112.9 86.2 115.3 88.7 115.3 91.7Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M203.9 123.8C203.9 123.8 212.9 158.8 197.9 176.8",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M121.8 137.9C125.39 137.9 128.3 133.871 128.3 128.9C128.3 123.929 125.39 119.9 121.8 119.9C118.21 119.9 115.3 123.929 115.3 128.9C115.3 133.871 118.21 137.9 121.8 137.9Z",
    fill: "#3A3A3A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M163.8 137.9C167.39 137.9 170.3 133.871 170.3 128.9C170.3 123.929 167.39 119.9 163.8 119.9C160.21 119.9 157.3 123.929 157.3 128.9C157.3 133.871 160.21 137.9 163.8 137.9Z",
    fill: "#3A3A3A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M142.8 157.9C146.39 157.9 149.3 152.527 149.3 145.9C149.3 139.273 146.39 133.9 142.8 133.9C139.21 133.9 136.3 139.273 136.3 145.9C136.3 152.527 139.21 157.9 142.8 157.9Z",
    fill: "#3A3A3A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M182.896 80.4168C184.332 77.9297 177.005 71.0111 166.531 64.9636C156.057 58.916 146.402 56.0297 144.966 58.5168C143.53 61.0038 150.857 67.9224 161.331 73.97C171.805 80.0175 181.461 82.9038 182.896 80.4168Z",
    fill: "#009D00"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M153.894 91.8176C156.421 91.5536 157.664 83.636 156.672 74.1331C155.679 64.6302 152.826 57.1405 150.299 57.4044C147.772 57.6684 146.529 65.586 147.521 75.089C148.514 84.5919 151.367 92.0816 153.894 91.8176Z",
    fill: "#009D00"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M148.344 75.5844C151.573 66.8276 152.259 59.0162 149.875 58.1372C147.492 57.2582 142.942 63.6444 139.712 72.4012C136.483 81.158 135.797 88.9694 138.18 89.8484C140.564 90.7274 145.114 84.3412 148.344 75.5844Z",
    fill: "#009D00"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M141.451 72.9043C146.398 65.1858 148.674 57.8175 146.535 56.4466C144.396 55.0758 138.652 60.2215 133.705 67.94C128.758 75.6585 126.482 83.0268 128.621 84.3977C130.759 85.7685 136.504 80.6228 141.451 72.9043Z",
    fill: "#009D00"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M134.168 68.3493C142.016 63.6095 147.313 58.0042 145.999 55.8295C144.686 53.6548 137.259 55.7343 129.412 60.4741C121.564 65.2139 116.267 70.8192 117.58 72.9939C118.894 75.1686 126.32 73.0891 134.168 68.3493Z",
    fill: "#009D00"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M126.37 62.5767C135.661 60.3486 142.712 56.5397 142.12 54.0693C141.527 51.5989 133.515 51.4025 124.224 53.6306C114.934 55.8587 107.882 59.6676 108.475 62.138C109.067 64.6084 117.079 64.8048 126.37 62.5767Z",
    fill: "#009D00"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M151.869 60.6115C155.509 59.0098 157.63 55.8263 156.607 53.5009C155.583 51.1756 151.803 50.589 148.164 52.1907C144.524 53.7924 142.403 56.9759 143.426 59.3013C144.45 61.6266 148.23 62.2132 151.869 60.6115Z",
    fill: "#6E3126"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M197.554 69.4993C198.32 66.7314 190.009 62.0158 178.99 58.9668C167.972 55.9178 158.419 55.69 157.653 58.4579C156.887 61.2258 165.198 65.9414 176.217 68.9904C187.235 72.0393 196.788 72.2672 197.554 69.4993Z",
    fill: "#009D00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_468",
    transform: "scale(0.0111111 0.0666667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_468",
    transform: "scale(0.1)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1_468",
    transform: "scale(0.1)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_468",
    x1: 79.4003,
    y1: 129.913,
    x2: 210.527,
    y2: 129.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F50028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F50028"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_468",
    x1: 143.829,
    y1: 131.413,
    x2: 210.672,
    y2: 131.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#3A3A3A",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5256,
    stopColor: "#3A3A3A"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_468",
    width: 90,
    height: 15,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAGmAAACAwAAAs7/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA8AWgMBIgACEQEDEQH/xACIAAACAwAAAAAAAAAAAAAAAAAEBQADBgEBAAAAAAAAAAAAAAAAAAAAABAAAAYDAQEBAAAAAAAAAAAAAAIDBAUGARYHFyAREQABAgQCBggHAAAAAAAAAAABAgMAEdEEQRIxoZMUBTUQIZGxMpKiE1Fh4VLCJDQSAQAAAAAAAAAAAAAAAAAAACD/2gAMAwEAAhEDEQAAAMVoUWqLLryAUqQoHPguXvADJrXKY//aAAgBAgABBQD6/9oACAEDAAEFAPr/2gAIAQEAAQUAYxjx+drzuXXTQ5ifJPMEQ35kyIfziEDnmkafHmCINzAn4pzaUIV/X5KPwI1eVROysd1RTbW2z4zt8yNvmRt8yNvmRt8yF7dYckXtF0UTlHticYH/2gAIAQICBj8AX//aAAgBAwIGPwBf/9oACAEBAQY/AMtuifzPUIC1uIbJwkVa+qBvF0QvHIABrnH9a+wUib9wtxP26O4CNK/MawPYeW0fjOc/NOP619gpByXap4TApBKX0Klhl+sZrhAkNOUzp0BXD0uLkfChBWNQiSuF3D4wIYdH4mDvPA7ojDIy4e9AjkN9sF0jkN9sF0jkN9sF0jkN9sF0jkN9sF0j9fgV4F4Z2HANSTCkp4PcNkjxey6ZegQd+adaTiC2pA9Q6P/Z"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1_468",
    width: 10,
    height: 10,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAF2AAABhQAAAbP/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAoACgMBIgACEQEDEQH/xABqAAEBAQAAAAAAAAAAAAAAAAAABQYBAQAAAAAAAAAAAAAAAAAAAAAQAQEBAQAAAAAAAAAAAAAAAAUAEAQRAAEDBQEAAAAAAAAAAAAAAAECEgQgEUFhAxMSAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQAAAIOdD//aAAgBAgABBQC//9oACAEDAAEFAL//2gAIAQEAAQUAMAM6gt//2gAIAQICBj8Af//aAAgBAwIGPwB//9oACAEBAQY/AO0/vK8pKXMSSLBpON0f/9k="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrawberry);
export default __webpack_public_path__ + "static/media/strawberry.494a8de147ea6a6444484979340e9b95.svg";
export { ForwardRef as ReactComponent };